import { commonTrackingEvents, tracking, type ProposalStep } from 'noddi-web';
import { useEffect } from 'react';
import { useBookingProposalAnalytics } from '../stores/bookingProposalStore';

/**
 * One `proposalStepViewed` per screen of the booking-proposal flow. Steps are
 * named rather than taken from the URL — every proposal has its own slug, so a
 * path is unique per recipient and cannot carry a funnel.
 *
 * `enabled` is for steps that redirect out before rendering: a summary that
 * bounces to the login gate was never seen, and counting it would put a step in
 * the funnel that no customer reached.
 */
export const useTrackProposalStep = (step: ProposalStep, enabled = true) => {
  const analytics = useBookingProposalAnalytics();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    tracking.track(commonTrackingEvents.proposalStepViewed, { ...analytics, step });
  }, [analytics, step, enabled]);
};
